export default {
      id: "life-expectancy-usage",
      viewBox: "0 0 27 32",
      url: __webpack_public_path__ + "sprite.svg#life-expectancy",
      toString: function () {
        return this.url;
      }
    }